import { roundNumber } from "src/utils/genericFunctions";

export const calculateSoldCasesPer1000 = (
  totalCasesSold: any,
  actualSalesOfTheWeek: number | null
) => {
  if (!actualSalesOfTheWeek) {
    return null;
  }
  return (+totalCasesSold / +actualSalesOfTheWeek) * 1000;
};

export const calculateProductRequired = (
  casesPerThousand: number | null,
  masterDisplay: number | null,
  forecastSales: number | null
): number | null => {
  if (forecastSales === null) {
    return null;
  }
  const productRequired =
    (+casesPerThousand * forecastSales) / 1000 + +masterDisplay;
  return roundNumber(productRequired, 0, 0);
};

export const calculateProductAvailable = (
  inventoryBackStore: number | null,
  inventoryCounter: number | null,
  order: number | null
): number | null => {
  if (
    inventoryBackStore === null &&
    inventoryCounter === null &&
    order === null
  ) {
    return null;
  }
  const productAvailable =
    (+inventoryBackStore || 0) + (+inventoryCounter || 0) + (+order || 0);
  return roundNumber(productAvailable, 0, 0);
};

export const calculateProductOverShort = (
  productAvailable: number | null,
  productRequired: number | null
) => {
  if (productAvailable === null && productRequired === null) {
    return null;
  }
  return +productAvailable - +productRequired;
};

export const calculateCasesSold = (
  nextDayInventoryBackStore: number | null,
  nextDayInventoryCounter: number | null,
  productAvailable: number | null,
  actualSales: number | null
): number | null => {
  if (!actualSales) {
    return null;
  }

  if (nextDayInventoryBackStore === null && nextDayInventoryCounter === null) {
    return +productAvailable;
  }

  const nextDayTotalInv =
    +nextDayInventoryBackStore + +nextDayInventoryCounter || 0;
  return +productAvailable - nextDayTotalInv;
};

export const calculateOrdered = (
  received: number | null,
  orderFactor: number | null,
  casesPerThousand: number | null,
  orderDayOverShort: number | null
) => {
  if (received === null) {
    // if there is no order factor, then return 0
    if (!+orderFactor || 0) {
      return null;
    }

    // if there is order factor, then calculate the product required from the order factor
    const productRequiredFromOrderFactor = +casesPerThousand * +orderFactor;
    const casesRequired = +orderDayOverShort * -1;
    // if the cases required is greater than the product required from the order factor, then return the cases required
    const casesUnderOver = casesRequired + productRequiredFromOrderFactor;

    if (casesUnderOver > 0) {
      return roundNumber(casesUnderOver, 0, 0);
    }
    return 0;
  } else {
    // if there is received, then return the received
    return received;
  }
};

export const calculateTotalCasesSold = (
  commodity: any,
  actualSalesOfTheWeek: number | null
) => {
  if (!actualSalesOfTheWeek) {
    return null;
  }
  let total = 0;
  for (let i = 0; i < 7; i++) {
    total += commodity.dailyProductData[i].casesSold || 0;
  }
  return total;
};

export const calculateOrderFactor = (
  currentWeekSalesData: any,
  totalForecastedSalesTillNextDeliveryDay: number,
  startDay: number
): number | null => {
  const isReceivedToday =
    currentWeekSalesData[startDay].receivedToday ||
    currentWeekSalesData[startDay].deliveredBy;

  if (!isReceivedToday) {
    return null;
  }

  let orderFactor = +currentWeekSalesData[startDay].forecastSales;
  let i = +startDay + 1;
  for (; i < 7; i++) {
    const isReceivedTodaySub =
      currentWeekSalesData[i].receivedToday ||
      currentWeekSalesData[i].deliveredBy;

    if (isReceivedTodaySub) {
      break;
    }
    orderFactor += +currentWeekSalesData[i].forecastSales;
  }
  if (i === 7) {
    return (orderFactor + totalForecastedSalesTillNextDeliveryDay) / 1000;
  }
  return orderFactor / 1000;
};

export const calculateMasterDisplay = (
  casesPerThousand: number | null,
  minForcastSales: number | null
): number | null => {
  if (casesPerThousand === null || minForcastSales === null) {
    return null;
  }
  return (+casesPerThousand * minForcastSales) / 1000;
};
